export default __webpack_public_path__ + "static/media/house-img.f2770e0a.jpg";